import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
    BB_BETFEED_LOADING_CSS_CLASS_BLOCK_NAME,
    BB_BETFEED_LOADING_ICON_CSS_CLASS_NAME,
    BB_BETFEED_LOADING_TEXT_CSS_CLASS_NAME,
    BB_BETFEED_LOADING_CONTAINER_CLASS,
} from '../../constants';

const Loading = (props) => {
    const {
        cssLoadingBackground,
        cssLoadingIcon,
        loadingText,
        reLoadForNewBets,
    } = props;

    const [ t ] = loadingText ? useTranslation() : [];
    const loadingClass = loadingText ? cssLoadingBackground : `${BB_BETFEED_LOADING_CSS_CLASS_BLOCK_NAME} ${cssLoadingBackground}`;

    return (
        <div className={loadingClass} onClick={ reLoadForNewBets }>
            <div className={BB_BETFEED_LOADING_CONTAINER_CLASS}>
                <div className={`${BB_BETFEED_LOADING_ICON_CSS_CLASS_NAME} ${cssLoadingIcon}`}></div>
                {loadingText && <div className={BB_BETFEED_LOADING_TEXT_CSS_CLASS_NAME}>{t(loadingText)}</div>}
            </div>
        </div>
    );
};

Loading.propTypes = {
    cssLoadingBackground: PropTypes.string.isRequired,
    cssLoadingIcon: PropTypes.string,
    loadingText: PropTypes.string,
    reLoadForNewBets: PropTypes.func,
};

export default Loading;
